import { Howl } from 'howler';
import hoot from '../../sounds/toolkit/hoot.mp3';
import forest from '../../sounds/toolkit/day-forest.mp3';
import waltz from '../../sounds/toolkit/waltz.mp3';
import magic from '../../sounds/toolkit/firefly.mp3';

export const CAMERA2 = 'camera-2';
export const CAMERA3 = 'camera-3';
export const CAMERA4 = 'camera-4';
export const CAMERA5 = 'camera-5';
export const CAMERA6 = 'camera-6';
export const BLINK = 'blink';
export const SHOW = 'show';
export const FALL = 'fall';
export const PEEPERS = 'scene-1-tree-peepers';
export const BIRD_BODY = 'scene-1-birdie-body';
export const STARTLED = 'startled';
export const SHAKE = 'shake';

export const hootSound = new Howl({
    src: [hoot],
});

export const forestSound = new Howl({
    src: [forest],
    volume: 0.2,
    loop: true,
});

export const waltzSound = new Howl({
    src: [waltz],
    volume: 1,
});

export const magicSound = new Howl({
    src: [magic],
    volume: 1,
});

export const addClass = (ele, cls) => {
    ele.classList.add(cls);
};

export const removeClass = (ele, cls) => {
    ele.classList.remove(cls);
};

export const switchClass = (ele, cls1, cls2) => {
    ele.classList.remove(cls1);
    ele.classList.add(cls2);
};

const isIOS9 = () => window.navigator.userAgent.indexOf('OS 9') !== -1;

const isIPad = () => window.navigator.userAgent.indexOf('iPad') !== -1;

export const lowerResolutionAnimation = () => ((isIOS9() || isIPad()) ? 'scene-lite' : '');

export const callWithDelay = (func, delay) => new Promise((resolve) => {
    setTimeout(() => {
        func();
        resolve();
    }, delay);
});
